import { useState, useEffect } from 'react';

/**
 * Hook that returns the scroll position of a container element
 * @param containerId The id of the container element
 */
const useContainerScrollPosition = (containerId: string) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const scrollableContainer = document.getElementById(containerId);
    const handleScroll = () => {
      setScrollPosition(scrollableContainer?.scrollLeft || 0);
    };
    scrollableContainer?.addEventListener('scroll', handleScroll);
    return () => {
      scrollableContainer?.removeEventListener('scroll', handleScroll);
    };
  }, [containerId]);

  return scrollPosition;
};

export default useContainerScrollPosition;
